function EntryController() {

	$('.openOverlay').on('click', $.proxy( this.handleOverlayOpen, this ) );
	$('.artOverlay, .closeButton').on('click', $.proxy( this.handleOverlayClose, this ) );

	$('.statementReadMore').on('click', $.proxy( this.handleReadMore, this ) );

	if( $('.statementHolder').height() < parseInt($('.statementHolder').css('max-height')) )
		$('.statementReadMore').hide();

	$('.entry.art img').on('load', $.proxy( this.handleEntryLoad, this ) );
	$('.entry.art img').attr('src', $('.entry.art img').data('src') );

	$(window).resize( $.proxy( this.handleResize, this ) );
	$(window).on('mediaQueryChange', $.proxy( this.handleMediaQueryChange, this ) );


	this.handleMediaQueryChange(null,$(window).width());

}


EntryController.prototype = {

	handleResize: function(e) {

		this.handleEntryLoad();

	},


	handleMediaQueryChange: function(e,width) {

		if( width < 640 ) {
			$('.entryArrow.next').css('right','0px');
			$('.entryArrow.next').off('mouseenter mouseleave');
			$('.entryArrow.prev').css('left','0px');
			$('.entryArrow.prev').off('mouseenter mouseleave');

		}

		if( width >= 640 ) { // TABS & DESKTOP
			$('.entryArrow.next').css('right','-130px');
			$('.entryArrow.prev').css('left','-130px');
			$('.entryArrow.next').hover( function(e) { $(this).animate({'right':'0px'}, 200 ); },function(e) { $(this).animate({'right':'-130px'}, 200 ); } );
			$('.entryArrow.prev').hover( function(e) { $(this).animate({'left':'0px'}, 200 ); },function(e) { $(this).animate({'left':'-130px'}, 200 ); } );
		}

	},

	handleEntryLoad: function(e) {

		if( $('.entry.art img').width() > $('.entry.art img').height() ) {
			//landscape
			$('.entry.art img').css('width','100%');
			$('.entry.art img').css('height','auto');

		} else {
			//portrait
			if( $(window).width() > 640 )
				$('.entry.art a').css('height','400px');
			else
				$('.entry.art a').css('height','300px');

			$('.entry.art img').css('width','auto');
			$('.entry.art img').css('height','100%');

		}

		var offset = ( $('.entry.art img').width() / 2 ) - $('.entry.art a div').width();

		if( $(window).width() > 640 ) {
			$('.entry.art a div').css('margin-left', offset + 'px');
			$('.entry.art a div').css('display', 'block');
		}

		$('.entry.art img').fadeIn(300);




	},

	handleReadMore: function(e) {
		$('.statementHolder').css('max-height','none');
		$('.statementReadMore').hide();
	},

	handleOverlayOpen: function(e) {
		e.preventDefault();

		if( $(window).width() < 640 )
			return;

		var image = $(e.currentTarget).attr('href');

		$('.artOverlay div').css('background-image',"url('/" + image + "')");
		$('.artOverlay').fadeIn(300);
		$('html,body').css('overflow','hidden');


	},

	handleOverlayClose: function(e) {
		$('.artOverlay').fadeOut(300);
		$('html,body').css('overflow','visible');
	}

};

module.exports = EntryController;



// WEBPACK FOOTER //
// ./js/src/EntryController.js